<!--user incidents info popup-->
<popup-c [hidden]="!accountCompromisedService.userIncidentsPopup?.show"
		 head="Suspicious Activity Information" size="large"
		 subTitle="View suspicious activity that occurred in one of your registered user's account"
		 (closeCb)="accountCompromisedService.userIncidentsPopup ? accountCompromisedService.userIncidentsPopup.show = false : null;"
		 [buttons]="{cancel: 'OK'}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: auto;">
		<span>User: <b>{{accountCompromisedService.userIncidentsPopup?.userIncidentsInfo[0]?.user_email}}</b></span>
		<!--incidents info table-->
		<trustifi-table-c
			class="trustifi-table" style="flex: 1 0; z-index: 5;"
			[list]="accountCompromisedService.userIncidentsPopup?.userIncidentsInfo"
			[headers]="[
				{text: 'Created', sortKey: 'created', width: '25%'},
				{text: 'Type', sortKey: 'incident_type'},
			]"
			[cellsPrototype]="[
				{textKey: 'created', textType: 'dateAndTime'},
				{html: 'incidentTypeCell'},
			]"
			[cellActions]="{
				enable: true,
				selectItemActionCb:	selectIncidentAction,
				initActionsFunction: showIncidentInfoActions
			}"
			(searchFunction)="searchIncidents($event.searchTerm, $event.activeFilters)"
			[options]="{
                        itemsNameSingular: 'incident',
                        defaultSortKey: '-created'
                    }"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--incident type cells-->
				<span *ngIf="cellId === 'incidentTypeCell'" style="color: darkred;">
					{{dic.CONSTANTS.accountCompromisedIncidentTypes[item.incident_type].name}}
				</span>
			</ng-template>
		</trustifi-table-c>
	</div>
</popup-c>

<!--incident info popup-->
<popup-c class="no-content-padding threat-protection-popup"
		 *ngIf="accountCompromisedService.incidentInfoPopup?.show"
		 size="fullscreen"
		 (ngInit)="incidentInfo = accountCompromisedService.incidentInfoPopup.IncidentInfo;">
	<div class="f-1-0 h100 w100 flxClmn" style="overflow: auto;" tabindex="0" [appAutoFocus]="true" focusDelay="20" (keydown.escape)="accountCompromisedService.incidentInfoPopup = null; getEmailContentInProcess = null;">
		<!--Popup header-->
		<div class="flxClmn-around tp-popup-header" style="flex: 1 0; max-height: 110px; padding: 10px 20px; border-bottom: solid 1px lightgrey; z-index: 100; background: linear-gradient(90deg, white,white 58%, #e9e9e9ad), url('images/popup-header-bg.png'); background-size: auto; background-repeat: round;">
			<div class="flxRow-between" style="align-items: center;">
				<div class="flxRow ellipsis hSpace2" style="align-items: center; padding-right: 5%;">
					<img src="images/favicon/favicon-32x32.png" style="width: 25px; margin: 0; image-rendering: -webkit-optimize-contrast;">
					<h3 class="ellipsis">Suspicious Activity Information</h3>
				</div>
				<a (click)="accountCompromisedService.incidentInfoPopup = null; getEmailContentInProcess = null; incidentInfo.emailInfo = null;">
					<i class="far fa-times" style="font-size: 1.3rem; padding: 10px;"></i>
				</a>
			</div>

			<div class="flxRow-between">
				<div class="flxRow hSpace2" style="align-items: center;">
					<div class="flxRow hSpace1" style="align-items: center; font-size: 1rem;">
						<span >Category:</span>
						<span style="font-weight: bold; color: var(--bs-danger);">{{dic.CONSTANTS.accountCompromisedIncidentTypes[incidentInfo.incident_type].name}}</span>
					</div>
					<div class="vertical-separator" style="border-width: 2px; margin: 0 1.5vw; border-color: darkgrey; border-left: none;"></div>
					<div class="flxRow hSpace1" style="font-size: 1rem; align-items: center;">
						<span>Mailbox:</span>
						<span style="font-weight: bold;">{{incidentInfo.user_email}}</span>
						<i (click)="getAccountCompromisedInfo({email: incidentInfo.user_email})" class="far fa-info-circle" style="cursor: pointer;" tooltip="View mailbox information"></i>
					</div>
				</div>
			</div>
		</div>

		<div class="flxRow h100" style="flex: 1 0; overflow: auto;">
			<!--Sidebar-->
			<div class="flxClmn tp-popup-sidebar" style="box-shadow: 0 0 5px grey; overflow: hidden; width: 235px; background: linear-gradient(45deg, #d9efff75, white); position: sticky; left: 0; top: 0; z-index: 50;">
				<div class="flxClmn" style="padding: max(1.2vw,15px);">
					<!--Actions-->
					<div class="flxClmn w100 vSpace05">
						<span style="font-family: 'Roboto Condensed', sans-serif; font-size: 1.1rem;">Email Actions</span>
						<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
					</div>
					<div class="flxRow" style="flex-wrap: wrap;">
						<btn-c class="quarantined-popup-action-btn f-1-0"
							   style="min-width: 52%; max-width: unset;"
							   *ngFor="let action of incidentActions"
							   (action)="selectAction(accountCompromisedService.incidentInfoPopup.IncidentInfo, action.display)">
							{{action.display}}
						</btn-c>
					</div>
					<div *ngIf="gs.reviewerInfo.is_security_reviewer" class="flxClmn w100" style="margin-top: 1rem; align-items: center;">
						 <span style="font-size: 1rem;">
							Security Reviewer Actions
						</span>
						<div style="background: linear-gradient(90deg, #9b9b9b, transparent); width: 100%; height: 1px; margin-bottom: min(15px,1vh);"></div>
						<div class="flxRow w100" style="flex-wrap: wrap;">
							<btn-c style="min-width: 52%; max-width: unset;"
								   class="quarantined-popup-action-btn f-1-0"
								   (action)="selectAction(accountCompromisedService.incidentInfoPopup.IncidentInfo, dic.CONSTANTS.quarantinedActions.createIncident.display)">
								{{dic.CONSTANTS.quarantinedActions.createIncident.display}}
							</btn-c>
						</div>

					</div>
				</div>
			</div>

			<div class="flxClmn" style="flex: 1 0;">
				<div class="threat-protection-grid h100" style="flex: 1 0; overflow: auto !important; padding: 0 1.75vw !important; grid-auto-rows: 1fr; min-height: 670px;">
					<div class="threat-protection-card  flxClmn f-1-0" style="overflow: auto;"
						 [ngClass]="accountCompromisedService.incidentInfoPopup.isUserAllowedToViewEmailContent ? 'ro24 co12' : 'ro24 co13'">
						<div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">
								Incident Description
							</span>
						</div>
						<div class="flxClmn animated fadeIn" style="flex: 1 0; overflow: auto;">
							<div class="flxClmn vSpace05" style="margin-bottom: 10px; font-size: 0.85rem; padding: max(15px,1vw); flex: 1 0;">
								<!--Warning label-->
								<span class="flxRow" style="align-items: center; margin: 0 0 15px; font-size: 1.15rem; color: orangered;"
									  *ngIf="accountCompromisedService.incidentInfoPopup.incidentDesc">
									<i class="far fa-exclamation-triangle" style="padding-right: 15px;"></i>
									{{accountCompromisedService.incidentInfoPopup.incidentDesc}}
								</span>
								<!--Warning details-->
								<div class="flxClmn" style="padding: 15px; flex: 1 0; overflow: auto;">
									<!--suspicious device-->
									<ng-container *ngIf="incidentInfo.incident_type === 'suspicious_device_change' && !incidentInfo.incident_info.new_login">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<!-- last device -->
											<span>
												<b>IP Address:</b> {{incidentInfo.incident_info.location[0].ip}}
											</span>

											<span>
												<b>Client:</b>&nbsp;
												<ng-container *ngIf="incidentInfo.incident_info.agent && incidentInfo.incident_info.agent.browser">{{incidentInfo.incident_info.agent.browser.name + ' (' + incidentInfo.incident_info.agent.browser.version + '), ' + incidentInfo.incident_info.agent.os.name + ' (' + incidentInfo.incident_info.agent.os.version + ')'}}</ng-container>
												<ng-container *ngIf="incidentInfo.incident_info.agent && !incidentInfo.incident_info.agent.browser && incidentInfo.incident_info.agent.raw">{{incidentInfo.incident_info.agent.raw.ua || 'N/A'}}</ng-container>
											</span>

											<span *ngIf="incidentInfo.email_title">
												<b>Email opened:</b> {{incidentInfo.email_title}}
											</span>

											<span>
												<b>Location:</b>&nbsp;
												<span *ngIf="incidentInfo.incident_info.location[0]">{{incidentInfo.incident_info.location[0].country}}{{incidentInfo.incident_info.location[0].city ? (', ' + incidentInfo.incident_info.location[0].city) : ''}}</span>
												<img style="cursor: pointer; padding-left: 3px;" *ngIf="incidentInfo.incident_info.location[0]?.ll" (click)="openLocation(incidentInfo.incident_info.location[0].ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
											</span>

											<br/>
											<!--all user's devices-->
											<span style="font-size: 15px;"><u>Known devices</u>:</span>

											<table class="w100 simpleDataTable">
												<thead><tr>
													<th style="width:35%;">Client</th>
													<th style="width:20%;">Location</th>
													<th style="width:20%;">IP Address</th>
													<th style="width:25%;">Last Used</th>
												</tr></thead>
												<tbody>
												<tr *ngFor="let device of incidentInfo.incidentInfo.devices | orderBy: '-last_used'">
													<td>
														<span *ngIf="device.agent && device.agent.browser">{{device.agent.browser.name + ' (' + device.agent.browser.version + '), ' + device.agent.os.name + ' (' + device.agent.os.version + ')'}}</span>
														<span *ngIf="device.agent && device.agent.raw && !device.agent.browser">{{device.agent.raw.ua || 'N/A'}}</span>
													</td>
													<td>
														<span *ngIf="device.location[0]">{{device.location[0].country}}{{device.location[0].city ? (', ' + device.location[0].city) : ''}}</span>
														<img style="cursor: pointer;" *ngIf="device.location && device.location[0].ll" (click)="openLocation(device.location[0].ll)" tooltip="Open in Google Maps" class="googleMaps" src="data:image/png;base64,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" alt=""/>
													</td>
													<td>
														<span>{{device.location[0].ip}}{{device.location[0].connection ? (' (' + device.location[0].connection + ')') : ''}}</span>
													</td>
													<td>
														<time>{{device.last_used | date: 'MM/dd/yyyy HH:mm' }}</time>
													</td>
												</tr>
												</tbody>
											</table>
										</div>
									</ng-container>

									<ng-container *ngIf="incidentInfo.incident_type === 'suspicious_device_change' && incidentInfo.incident_info.new_login">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<span>An unknown device has logged into this user's mailbox.</span><br/><br/>

											<!-- last device -->
											<span style="text-decoration: underline; font-size: 15px;">New device info:</span>

											<table style="border-collapse: separate; border-spacing: 10px;">
												<tr>
													<td><b>Operating System:</b></td>
													<td>
														<span>{{incidentInfo.incident_info.agent.os.name}}</span>
														<span *ngIf="incidentInfo.incident_info.agent.os.version"> ({{incidentInfo.incident_info.agent.os.version}})</span>
													</td>
												</tr>

												<tr>
													<td><b>Device Name:</b></td>
													<td><span>{{incidentInfo.incident_info.display_name}}</span></td>
												</tr>

												<tr>
													<td><b>Device ID:</b></td>
													<td><span>{{incidentInfo.incident_info.device_id}}</span></td>
												</tr>

												<tr *ngIf="incidentInfo.incident_info.registrationDateTime">
													<td><b>Login Time:</b></td>
													<td><span>{{incidentInfo.incident_info.registrationDateTime | date: 'MM/dd/yyyy HH:mm'}}</span></td>
												</tr>
											</table>
										</div>
									</ng-container>

									<!--high_recipient_compliant_rate-->
									<ng-container *ngIf="incidentInfo.incident_type === 'high_recipient_compliant_rate'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<span>The user's emails have been reported multiple times as spam or phishing by recipients</span>
											<span>{{incidentInfo.incident_info.isUserBlocked ? 'The user has been blocked' : 'The user has not yet been blocked'}}</span>

											<span style="font-size: 15px;"><u>Recipient Complaints</u>:</span>

											<div>
												<table class="w100 simpleDataTable">
													<thead><tr>
														<th style="width:35%;">Email</th>
														<th style="width:20%;">Recipient</th>
														<th style="width:20%;">Complaint</th>
													</tr></thead>
													<tbody>
													<tr *ngFor="let eventObj of incidentInfo.incident_info.eventsInfo | orderBy: '-created'">
														<td>
															<span>{{eventObj.emailTitle}}</span>
														</td>
														<td>
															<span>{{eventObj.recipient}}</span>
														</td>
														<td>
															<time>{{eventObj.created | date: 'MM/dd/yyyy HH:mm' }}</time>
														</td>
													</tr>
													</tbody>
												</table>
											</div>
										</div>
									</ng-container>

									<ng-container *ngIf="incidentInfo.incident_type === 'abnormal_user_activity'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<span>{{incidentInfo.incident_info.metric_label}}</span>

											<div *ngIf="incidentInfo.incident_info.forward_to">
												<span><b>Forwarding Email: </b></span>{{incidentInfo.incident_info.forward_to}}
											</div>

											<div *ngIf="incidentInfo.incident_info.ip">
												<span><b>IP Address: </b></span>{{incidentInfo.incident_info.ip}}
											</div>

											<div *ngIf="incidentInfo.incident_info.location?.country">
												<span><b>Location: </b></span>
												<span *ngIf="incidentInfo.incident_info.location.city">{{incidentInfo.incident_info.location.city}}, </span>
												{{incidentInfo.incident_info.location.country}}
											</div>
										</div>
									</ng-container>


									<!--high_recipient_hard_bounce_rate-->
									<ng-container *ngIf="incidentInfo.incident_type === 'high_recipient_hard_bounce_rate'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<span>The user's emails have been bounced on high rate lately</span>
											<span>{{incidentInfo.incident_info.isUserBlocked ? 'The user has been blocked' : 'The user has not yet been blocked'}}</span>

											<span style="font-size: 15px;"><u>Recipient Hard Bounce</u>:</span>

											<table class="w100 simpleDataTable">
												<thead><tr>
													<th style="width:35%;">Email</th>
													<th style="width:20%;">Recipient</th>
													<th style="width:20%;">Bounce</th>
												</tr></thead>
												<tbody>
												<tr *ngFor="let eventObj of incidentInfo.incident_info.eventsInfo | orderBy: '-created'">
													<td>
														<span>{{eventObj.emailTitle}}</span>
													</td>
													<td>
														<span>{{eventObj.recipient}}</span>
													</td>
													<td>
														<time>{{eventObj.created | date: 'MM/dd/yyyy HH:mm' }}</time>
													</td>
												</tr>
												</tbody>
											</table>
										</div>
									</ng-container>

									<!--suspicious location-->
									<div class="flxClmn f-1-0" *ngIf="incidentInfo.incident_type === 'suspicious_location_change'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<span>
												<b>New location detected:</b> {{incidentInfo.incident_info.location[0].city && (incidentInfo.incident_info.location[0].city + ", ")}}{{incidentInfo.incident_info.location[0].country}}
											</span>

											<span>
												<b>IP Address:</b> {{incidentInfo.incident_info.location[0].ip}}
											</span>

											<span>
												<b>Client:</b>&nbsp;
												<ng-container *ngIf="incidentInfo.incident_info.agent && incidentInfo.incident_info.agent.browser">{{incidentInfo.incident_info.agent.browser.name + ' (' + incidentInfo.incident_info.agent.browser.version + '), ' + incidentInfo.incident_info.agent.os.name + ' (' + incidentInfo.incident_info.agent.os.version + ')'}}</ng-container>
												<ng-container *ngIf="incidentInfo.incident_info.agent && !incidentInfo.incident_info.agent.browser && incidentInfo.incident_info.agent.raw">{{incidentInfo.incident_info.agent.raw.ua || 'N/A'}}</ng-container>
											</span>

											<span *ngIf="incidentInfo.email_title">
												<b>Email opened:</b> {{incidentInfo.email_title}}
											</span>

											<div class="flxClmn f-1-0 w100" style="margin-top: 10px;">
												<leaflet-c class="f-1-0 w100" [leafletCenter]="incidentInfo.incident_info.center_location" [markers]="incidentInfo.incident_info.locations"></leaflet-c>
											</div>
										</div>
									</div>

									<!--suspicious amount of emails-->
									<ng-container *ngIf="incidentInfo.incident_type === 'sending_unusual_amount_of_emails'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<div *ngIf="incidentInfo.incident_info.recentWeekCount" class="flxClmn vSpace1 f-1-0" style="overflow: auto;">
												<span>Time period: <b>{{incidentInfo.incident_info.timeSlot}} GMT</b></span>
												<span>Number of emails sent: <b>{{incidentInfo.incident_info.recentWeekCount}}</b></span>
												<span>Average for this time period: <b>{{incidentInfo.incident_info.avgEmails}}</b></span>

												<div class="flxClmn f-1-0" style="overflow: auto;" *ngIf="incidentInfo.incidentInfo.emails">
													<br/>
													<h5>Emails</h5>
													<trustifi-table-c
														class="trustifi-table" style="flex: 1 0; z-index: 5; min-height: 300px;"
														[list]="incidentInfo.incidentInfo.emails"
														[headers]="[
																{text: 'Created', sortKey: 'created', width: '20%'},
																{text: 'Subject', sortKey: 'sent.title', width: '35%'},
																{text: 'Recipients', width: '45%'},
															  ]"
														[cellsPrototype]="[
																{textKey: 'created', textType: 'dateAndTime'},
																{textKey: 'sent.title'},
																{textKey: 'recipients'},
															  ]"
														[options]="{}"
													>
													</trustifi-table-c>
												</div>
											</div>

											<div *ngIf="incidentInfo.incident_info.newRecipientsCount" class="flxClmn vSpace1 f-1-0" style="overflow: auto;">

												<div *ngIf="incidentInfo.email_title">
													<b>Email sent: </b>
													<span>{{incidentInfo.email_title}}</span>
												</div>

												<div>
													<b>Amount of recipients in this email: </b>
													<span>{{incidentInfo.incident_info.newRecipientsCount}}</span>
												</div>

											</div>
										</div>
									</ng-container>

									<!--sending_burst_emails-->
									<ng-container *ngIf="incidentInfo.incident_type === 'sending_burst_emails'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<div class="flxClmn vSpace1 f-1-0" style="overflow: auto;">
												<span>Number of recipients: <b>{{incidentInfo.incident_info.numRecipients}}</b></span>
												<span>Recipient domains: <b>{{incidentInfo.incident_info.domains.join(', ')}}</b></span>

												<div class="flxClmn f-1-0" style="overflow: auto;" *ngIf="incidentInfo.incidentInfo.emails">
													<br/>
													<h5>Emails</h5>
													<trustifi-table-c
														class="trustifi-table" style="flex: 1 0; z-index: 5; min-height: 300px;"
														[list]="incidentInfo.incidentInfo.emails"
														[headers]="[
																{text: 'Created', sortKey: 'created', width: '20%'},
																{text: 'Subject', sortKey: 'sent.title', width: '35%'},
																{text: 'Recipients', width: '45%'},
															  ]"
														[cellsPrototype]="[
																{textKey: 'created', textType: 'dateAndTime'},
																{textKey: 'sent.title'},
																{textKey: 'recipients'},
															  ]"
														[options]="{}"
													>
													</trustifi-table-c>
												</div>
											</div>
										</div>
									</ng-container>

									<!--outbound_malicious_quarantines-->
									<ng-container *ngIf="incidentInfo.incident_type === 'outbound_malicious_quarantines'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<div class="flxClmn vSpace1 f-1-0" style="overflow: auto;">
												<table class="w100 simpleDataTable" *ngIf="incidentInfo.incidentInfo?.type === dic.CONSTANTS.quarantinedOutboundType.malicious && incidentInfo.incidentInfo?.info">
													<tr>
														<th style="padding: 0; border: none; width: 150px;"></th>
														<th style="padding: 0; border: none;"></th>
													</tr>
													<tr>
														<td><b>Email Subject: </b></td>
														<td>
															<span>{{incidentInfo.email_title}}</span>
														</td>
													</tr>
													<tr>
														<td><b>Quarantine type: </b></td>
														<td>
															<span>{{dic.CONSTANTS.quarantinedOutboundType[incidentInfo.incident_info.type] || incidentInfo.incident_info.type}}</span>
														</td>
													</tr>
												</table>


												<!--malicious links-->
												<table class="w100 simpleDataTable" *ngIf="incidentInfo.incidentInfo?.type === dic.CONSTANTS.quarantinedOutboundType.malicious && incidentInfo.incidentInfo?.info">
													<tr *ngIf="incidentInfo.incidentInfo?.info.url">
														<th style="padding: 0; border: none; width: 150px;"></th>
														<th style="padding: 0; border: none;"></th>
													</tr>
													<tr *ngIf="incidentInfo.incidentInfo?.info.url">
														<td><b>URL address: </b></td>
														<td>
															<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">{{incidentInfo.incidentInfo?.info.url}}</span>
														</td>
													</tr>
													<tr *ngIf="incidentInfo.incidentInfo?.info.domain">
														<td><b>Domain: </b></td>
														<td>
															<span>{{incidentInfo.incidentInfo?.info.domain}}</span>
															<span *ngIf="incidentInfo.incidentInfo?.info.is_black_list"> (Blocklist)</span>
														</td>
													</tr>
													<tr *ngIf="incidentInfo.incidentInfo?.info.sub_status && incidentInfo.incidentInfo?.info.sub_status.length">
														<td><b>Detection{{incidentInfo.incidentInfo?.info.sub_status.length > 1 ? 's' : ''}}: </b></td>
														<td>
															<div class="flxClmn vSpace1">
																<div *ngFor="let detection of incidentInfo.incidentInfo?.info.sub_status" class="flxRow hSpace1" style="color: darkred;">
																	<i class="far fa-exclamation-triangle"></i>
																	<span>{{detection.message}}</span>
																</div>
															</div>
														</td>
													</tr>
													<tr>
														<td><b>Current email status: </b></td>
														<td>
															<span style="text-transform: capitalize;">{{incidentInfo.incidentInfo?.status}}</span>
														</td>
													</tr>
												</table>

												<!--malicious file-->
												<table class="w100 simpleDataTable" *ngIf="incidentInfo.incidentInfo.type === dic.CONSTANTS.quarantinedOutboundType.maliciousFiles && incidentInfo.incidentInfo.info">
													<tr *ngIf="incidentInfo.incidentInfo.info.file_name">
														<th style="padding: 0; border: none; width: 150px;"></th>
														<th style="padding: 0; border: none;"></th>
													</tr>
													<tr *ngIf="incidentInfo.incidentInfo.info.file_name">
														<td><b>File name: </b></td>
														<td>
															<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
																{{incidentInfo.incidentInfo.info.file_name}}
															</span>
														</td>
													</tr>
													<tr *ngIf="incidentInfo.incidentInfo.info.malware_type">
														<td><b>Malware Type: </b></td>
														<td>
												<span style="word-break: break-word; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 8; -webkit-box-orient: vertical;">
													{{incidentInfo.incidentInfo.info.malware_type}}
												</span>
														</td>
													</tr>
												</table>
											</div>
										</div>
									</ng-container>

									<!--suspicious sensitive data to new domain-->
									<ng-container *ngIf="incidentInfo.incident_type === 'sending_sensitive_to_new_domains'">
										<div class="flxClmn f-1-0 bs-enabled vSpace1" style="overflow: auto;">
											<span><b>Email Subject:</b> {{incidentInfo.email_title}}</span>
											<span><b>Recipient Domain:</b> {{incidentInfo.incident_info.domain}}</span>
											<span><b>Encrypt Content:</b> {{incidentInfo.incidentInfo?.email?.methods.encrypt_content ? 'True': 'False'}}</span>
											<span><b>Require Authentication:</b> {{incidentInfo.incidentInfo?.email?.methods.secure_send ? 'True' : 'False'}}</span>

											<br/>
											<trustifi-table-c
												*ngIf="incidentInfo.incident_info.sensitivity.sensitive_types?.length"
												class="trustifi-table" style="flex: 1 0; z-index: 5; min-height: 300px;"
												[list]="incidentInfo.incident_info.sensitivity.sensitive_types"
												[headers]="[
														{text: 'Type', sortKey: 'sensitive_type'},
														{text: 'Score', sortKey: 'score', width: '70px'},
														{text: 'Content'},
														{text: 'Compliance'},
													]"
												[cellsPrototype]="[
														{textKey: 'sensitive_type'},
														{textKey: 'score'},
														{html: 'contentCell'},
														{html: 'complianceCell'},
													]"
												[options]="{
														isEllipsis: false,
														itemsNameSingular: 'type',
													}"
											>
												<ng-template #customCells let-item let-cellId="cellId">
													<div *ngIf="cellId === 'contentCell'">
														<div class="px-2 py-1 border rounded-1 flex-row gap-2">
																<span class="f-1-0 break-word ellipsis">
																	{{item.content}}
																</span>
															<i tooltip="Copy" class="far fa-copy copy-link" style="cursor: pointer; color: #999999;" (click)="clipboard.copy(item.content);"></i>
														</div>
													</div>

													<div *ngIf="cellId === 'complianceCell'">
														<div class="value flex-row gap-2 justify-content-start flex-wrap">
															{{item.compliance.join(', ')}}
														</div>
													</div>
												</ng-template>

												<div tableButtons>
													<div class="flex-row gap-2" style="text-align: center; align-items: center;">
														<div class="flex-row p-1 rounded-1 align-items-center gap-1" style="border: 1px solid; width: 150px; padding: 5px; border-radius: 5px;"
															 [ngStyle]="incidentInfo.incident_info.sensitivity.score === 0 && {'background-color':'#32cd324d', 'border-color':'limegreen'} || incidentInfo.incident_info.sensitivity.score < 4 && {'background-color':'#ff8c004d', 'border-color':'darkorange'} || incidentInfo.incident_info.sensitivity.score < 5 && {'background-color':'#FF851B4d', 'border-color':'#FF851B'} || incidentInfo.incident_info.sensitivity.score === 5 && {'background-color':'#FF41364d', 'border-color':'#FF4136' }">
															<div class="header">Sensitivity Score:</div>
															<input type="button" value="{{incidentInfo.incident_info.sensitivity.score}}"
																   [ngStyle]="incidentInfo.incident_info.sensitivity.score === 0 && {'background':'limegreen'} || incidentInfo.incident_info.sensitivity.score < 4 && {'background':'darkorange'} || incidentInfo.incident_info.sensitivity.score < 5 && {'background':'#FF851B'} || incidentInfo.incident_info.sensitivity.score === 5 && {'background':'#FF4136'}"
																   class="redborder" style="cursor: unset; width: 25px; margin: 0; padding-top: 4px; padding-bottom: 4px; border: 0; color: white !important;"
																   tooltip="Reflects how sensitive the content found in the email is on a scale of 0 (not sensitive) to 5 (extremely sensitive)" placement="right">
														</div>
														<div>
															<a (click)="openReportWrongSensitivityPopup()">Seems wrong? Click here to report</a>
														</div>
													</div>
												</div>
											</trustifi-table-c>
										</div>
									</ng-container>

									<!--suspicious sensitive data to personal email-->
									<ng-container *ngIf="incidentInfo.incident_type === 'sending_sensitive_to_personal_email'">
										<div class="flxClmn bs-enabled f-1-0 vSpace2" style="overflow: auto;">

											<span><b>Email Subject:</b> {{incidentInfo.email_title}}</span>
											<span><b>Recipient Domain:</b> {{incidentInfo.incident_info.domain}}</span>
											<span><b>Encrypt Content:</b> {{incidentInfo.incidentInfo?.email?.methods.encrypt_content ? 'True': 'False'}}</span>
											<span><b>Require Authentication:</b> {{incidentInfo.incidentInfo?.email?.methods.secure_send ? 'True' : 'False'}}</span>

											<br/>
											<trustifi-table-c
												*ngIf="incidentInfo.incident_info.sensitivity.sensitive_types?.length"
												class="trustifi-table" style="flex: 1 0; z-index: 5; min-height: 300px;"
												[list]="incidentInfo.incident_info.sensitivity.sensitive_types"
												[headers]="[
														{text: 'Type', sortKey: 'sensitive_type'},
														{text: 'Score', sortKey: 'score', width: '70px'},
														{text: 'Content'},
														{text: 'Compliance'},
													]"
												[cellsPrototype]="[
														{textKey: 'sensitive_type'},
														{textKey: 'score'},
														{html: 'contentCell'},
														{html: 'complianceCell'},
													]"
												[options]="{
														isEllipsis: false,
														itemsNameSingular: 'type',
													}"
											>
												<ng-template #customCells let-item let-cellId="cellId">
													<div *ngIf="cellId === 'contentCell'">
														<div class="px-2 py-1 border rounded-1 flex-row gap-2">
															<span class="f-1-0 break-word ellipsis">
																{{item.content}}
															</span>
															<i tooltip="Copy" class="far fa-copy copy-link" style="cursor: pointer; color: #999999;" (click)="clipboard.copy(item.content);"></i>
														</div>
													</div>

													<div *ngIf="cellId === 'complianceCell'">
														<div class="value flex-row gap-2 justify-content-start flex-wrap">
															{{item.compliance.join(', ')}}
														</div>
													</div>
												</ng-template>

												<div tableButtons>
													<div class="flex-row gap-2" style="text-align: center; align-items: center;">
														<div class="flex-row p-1 rounded-1 align-items-center gap-1" style="border: 1px solid; width: 150px; padding: 5px; border-radius: 5px;"
															 [ngStyle]="incidentInfo.incident_info.sensitivity.score === 0 && {'background-color':'#32cd324d', 'border-color':'limegreen'} || incidentInfo.incident_info.sensitivity.score < 4 && {'background-color':'#ff8c004d', 'border-color':'darkorange'} || incidentInfo.incident_info.sensitivity.score < 5 && {'background-color':'#FF851B4d', 'border-color':'#FF851B'} || incidentInfo.incident_info.sensitivity.score === 5 && {'background-color':'#FF41364d', 'border-color':'#FF4136' }">
															<div class="header">Sensitivity Score:</div>
															<input type="button" value="{{incidentInfo.incident_info.sensitivity.score}}"
																   [ngStyle]="incidentInfo.incident_info.sensitivity.score === 0 && {'background':'limegreen'} || incidentInfo.incident_info.sensitivity.score < 4 && {'background':'darkorange'} || incidentInfo.incident_info.sensitivity.score < 5 && {'background':'#FF851B'} || incidentInfo.incident_info.sensitivity.score === 5 && {'background':'#FF4136'}"
																   class="redborder" style="cursor: unset; width: 25px; margin: 0; padding-top: 4px; padding-bottom: 4px; border: 0; color: white !important;"
																   tooltip="Reflects how sensitive the content found in the email is on a scale of 0 (not sensitive) to 5 (extremely sensitive)" placement="right">
														</div>
														<div>
															<a (click)="openReportWrongSensitivityPopup()">Seems wrong? Click here to report</a>
														</div>
													</div>
												</div>
											</trustifi-table-c>
										</div>
									</ng-container>

									<!--email breach-->
									<ng-container *ngIf="incidentInfo.incident_type === 'email_breach'">
										<div class="flxClmn f-1-0 vSpace2" style="overflow: auto;">
											<div>
												<span *ngIf="!accountCompromisedService.incidentInfoPopup.incidentDesc">Trustifi has detected that a recent data breach contains personal information for this mailbox. <br></span>
												It is highly recommended to change the mailbox password as it may have been leaked in the darknet.
											</div>
											<br>
											<label style="margin-right: 5px;"><b>Breach Date: </b></label>{{incidentInfo.incident_info.date | date: 'MM/dd/yyyy'}}

											<div class="flxRow hSpace1">

												<span><b>Breach Information:</b>&nbsp;<span [innerHTML]="incidentInfo.incident_info.description"></span></span>
											</div>
										</div>
									</ng-container>

									<!--new_forward_redirect_rules-->
									<ng-container *ngIf="incidentInfo.incident_type === 'new_forward_redirect_rules'">
										<div class="flxClmn f-1-0 vSpace2 bs-enabled" style="overflow: auto;">
											<div class="p-2 flex-column gap-5 f-1-0 border border-primary rounded overflow-auto">
												<div *ngIf="incidentInfo?.incident_info?.actionSummary && !incidentInfo?.incident_info?.ruleObj" class="flex-column gap-3">
													<span style="text-decoration: underline;">Rule information:</span>
													<span>Name:
														<ng-container *ngIf="accountCompromisedService.getSuspiciousMailboxRuleDisplayName(incidentInfo.incident_info) as ruleName; else noMailboxRuleNameCompact">
															{{ruleName}}
														</ng-container>
														<ng-template #noMailboxRuleNameCompact><i style="color: var(--bs-secondary); font-style: italic;">No rule name</i></ng-template>
													</span>
													<span>Conditions: Apply to all messages <i style="font-weight: 400;" class="far fa-question-circle" tooltip="No condition found. The actions apply to all messages"></i></span>
													<span>Actions: {{incidentInfo.incident_info.actionSummary}}</span>
													<span *ngIf="incidentInfo.incident_info.redirect || incidentInfo.incident_info.forward">{{incidentInfo.incident_info.redirect ? 'Redirect' : 'Forward'}} to: {{incidentInfo.incident_info.redirect || incidentInfo.incident_info.forward}}</span>
												</div>

												<ng-container *ngIf="incidentInfo.incident_info.ruleObj">
													<span style="text-decoration: underline;">Rule information:</span>
													<span>Name:
														<ng-container *ngIf="accountCompromisedService.getSuspiciousMailboxRuleDisplayName(incidentInfo.incident_info) as ruleName; else noMailboxRuleNameRuleObj">
															{{ruleName}}
														</ng-container>
														<ng-template #noMailboxRuleNameRuleObj><i style="color: var(--bs-secondary); font-style: italic;">No rule name</i></ng-template>
													</span>

													<!--Conditions-->
													<div *ngIf="hasMailboxRuleConditions(incidentInfo?.incident_info?.ruleObj?.conditions)" class="flex-column gap-3">
														<span>Conditions:</span>
														<ng-container *ngFor="let desc of conditionDescriptors">
															<div *ngIf="incidentInfo.incident_info.ruleObj.conditions[desc.propKey] != null" [ngSwitch]="desc.type" class="flex-row gap-1">
																<!-- array_of_strings -->
																<div *ngSwitchCase="'array_of_strings'" class="flex-row gap-1" style="padding-left: 1rem;">
																	<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																	<span>{{ incidentInfo.incident_info.ruleObj.conditions[desc.propKey].join(', ') }}</span>
																</div>

																<!-- array_of_recipients -->
																<div *ngSwitchCase="'array_of_recipients'" class="flex-row gap-1" style="padding-left: 1rem;">
																	<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																	<div class="flex-row flex-wrap justify-content-start">
																		<span *ngFor="let recipient of incidentInfo.incident_info.ruleObj.conditions[desc.propKey]; let first = first">{{ first ? '' : ', ' }}{{ recipient?.emailAddress?.address }}</span>
																	</div>
																</div>

																<!-- boolean -->
																<div *ngSwitchCase="'boolean'" class="flex-row gap-1" style="padding-left: 1rem;">
																	<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																	<span>{{ incidentInfo.incident_info.ruleObj.conditions[desc.propKey] ? 'Yes' : 'No' }}</span>
																</div>

																<!-- sizeRange -->
																<div *ngSwitchCase="'sizeRange'" class="flex-row gap-1" style="padding-left: 1rem;">
																	<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																	<span *ngIf="incidentInfo.incident_info.ruleObj.conditions[desc.propKey].minimumSize">
																		Minimum {{ incidentInfo.incident_info.ruleObj.conditions[desc.propKey].minimumSize }} KB
																	</span>
																	<span *ngIf="incidentInfo.incident_info.ruleObj.conditions[desc.propKey].maximumSize">
																		Maximum {{ incidentInfo.incident_info.ruleObj.conditions[desc.propKey].maximumSize }} KB
																	</span>
																</div>

																<!-- string -->
																<div *ngSwitchCase="'string'" class="flex-row gap-1" style="padding-left: 1rem;">
																	<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																	<span>{{ incidentInfo.incident_info.ruleObj.conditions[desc.propKey] }}</span>
																</div>

																<!-- fallback -->
																<div *ngSwitchDefault class="flex-row gap-1">
																	<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																	<span>{{ incidentInfo.incident_info.ruleObj.conditions[desc.propKey] }}</span>
																</div>
															</div>
														</ng-container>
													</div>

													<span *ngIf="!hasMailboxRuleConditions(incidentInfo?.incident_info?.ruleObj?.conditions)">Conditions: Apply to all messages <i style="font-weight: 400;" class="far fa-question-circle" tooltip="No condition found. The actions apply to all messages"></i></span>

												<!--Exceptions-->
												<div *ngIf="incidentInfo?.incident_info?.ruleObj?.exceptions as exceptions" class="flex-column gap-3">
													<span style="font-size: 1rem;">Exceptions:</span>
													<ng-container *ngFor="let desc of conditionDescriptors">
														<div *ngIf="exceptions[desc.propKey] != null" [ngSwitch]="desc.type" class="flex-row gap-1">

															<!-- array_of_strings -->
															<div *ngSwitchCase="'array_of_strings'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ exceptions[desc.propKey].join(', ') }}</span>
															</div>

															<!-- array_of_recipients -->
															<div *ngSwitchCase="'array_of_recipients'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<div class="flex-row flex-wrap justify-content-start">
																	<span *ngFor="let recipient of exceptions[desc.propKey]; let first = first">{{ first ? '' : ', ' }}{{ recipient?.emailAddress?.address }}</span>
																</div>
															</div>

															<!-- boolean -->
															<div *ngSwitchCase="'boolean'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ exceptions[desc.propKey] ? 'Yes' : 'No' }}</span>
															</div>

															<!-- sizeRange -->
															<div *ngSwitchCase="'sizeRange'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span *ngIf="exceptions[desc.propKey].minimumSize">
																	Minimum {{ exceptions[desc.propKey].minimumSize }} KB
																</span>
																<span *ngIf="exceptions[desc.propKey].maximumSize">
																	Maximum {{ exceptions[desc.propKey].maximumSize }} KB
																</span>
															</div>

															<!-- string -->
															<div *ngSwitchCase="'string'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ exceptions[desc.propKey] }}</span>
															</div>

															<!-- fallback -->
															<div *ngSwitchDefault class="flex-row gap-1">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ exceptions[desc.propKey] }}</span>
															</div>
														</div>
													</ng-container>
												</div>

												<!--Actions-->
												<div *ngIf="incidentInfo?.incident_info?.ruleObj?.actions as actions" class="flex-column gap-3">
													<span style="font-size: 1rem;">Actions:</span>
													<ng-container *ngFor="let desc of actionDescriptors">
														<div *ngIf="actions[desc.propKey] != null" [ngSwitch]="desc.type" class="flex-row gap-1">

															<!-- array_of_strings -->
															<div *ngSwitchCase="'array_of_strings'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ actions[desc.propKey].join(', ') }}</span>
															</div>

															<!-- array_of_recipients -->
															<div *ngSwitchCase="'array_of_recipients'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<div class="flex-row flex-wrap justify-content-start">
																	<span *ngFor="let recipient of actions[desc.propKey]; let first = first">{{ first ? '' : ', ' }}{{recipient?.emailAddress?.address}}</span>
																</div>
															</div>

															<!-- boolean -->
															<div *ngSwitchCase="'boolean'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ actions[desc.propKey] ? 'Yes' : 'No' }}</span>
															</div>

															<!-- string -->
															<div *ngSwitchCase="'string'" class="flex-row gap-1" style="padding-left: 1rem;">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ actions[desc.propKey] }}</span>
															</div>

															<!-- fallback -->
															<div *ngSwitchDefault class="flex-row gap-1">
																<strong style="flex-shrink: 0;">{{ desc.label }}:</strong>
																<span>{{ actions[desc.propKey] }}</span>
															</div>
														</div>
													</ng-container>
												</div>
												</ng-container>

												<div *ngIf="!incidentInfo?.incident_info?.actionSummary && !incidentInfo?.incident_info?.ruleObj && (incidentInfo.incident_info.redirect || incidentInfo.incident_info.forward)" class="flex-column gap-3">
													<span style="text-decoration: underline;">Rule information:</span>
													<span>{{incidentInfo.incident_info.redirect ? 'Redirect' : 'Forward'}} to: {{incidentInfo.incident_info.redirect || incidentInfo.incident_info.forward}}<ng-container *ngIf="incidentInfo.incident_info.recipient_free_email_domain"> (free email domain)</ng-container></span>
												</div>
											</div>
										</div>
									</ng-container>
								</div>
							</div>
						</div>
					</div>

					<div class="threat-protection-card ro15 co12 flxClmn f-1-0" style="position: relative; overflow: auto; min-height: min(330px,50vh);"
						 *ngIf="accountCompromisedService.incidentInfoPopup.isUserAllowedToViewEmailContent">
						<div class="card-header flxRow-between" style="align-items: center;">
							<span class="card-title">
								Email Content
							</span>
							<div class="flxRow hSpace1" [ngClass]="{'disabled' : !incidentInfo.emailInfo}">
							</div>
						</div>
						<div class="flxClmn vSpace05" style="flex: 1 0; overflow: auto; padding: 15px 20px 10px;">
							<div class="flxClmn f-1-0" style="overflow: auto; min-width: 220px; position: relative;">
								<table class="w100 simpleDataTableShrink" style="table-layout: fixed;" *ngIf="incidentInfo.emailInfo">
									<tr>
										<th style="padding: 0; max-height: 0; width: 55px;"></th>
										<th style="padding: 0; max-height: 0;"></th>
									</tr>
									<tr>
										<td><b>From: </b></td>
										<td>
											<span>{{incidentInfo.emailInfo.from.name && incidentInfo.emailInfo.from.name !== incidentInfo.emailInfo.from.email ? incidentInfo.emailInfo.from.name + ' (' + incidentInfo.emailInfo.from.email + ')' : incidentInfo.emailInfo.from.email}}</span>
										</td>
									</tr>
									<tr>
										<td><b>To: </b></td>
										<td>
											<span>
												{{_.truncate(_.map(incidentInfo.emailInfo.recipients.to, 'address').join(', '), {length: showMore.to ? 99999999 : 150, separator: ','})}}
												<a class="blue-link" style="text-decoration: underline;" *ngIf="incidentInfo.emailInfo.recipients.to.join(', ').length > 150" (click)="showMore.to = !showMore.to">
													Show {{showMore.to ? 'less' : 'more'}}
												</a>
											</span>
										</td>
									</tr>
									<tr *ngIf="incidentInfo.emailInfo.recipients?.cc?.length">
										<td><b>Cc: </b></td>
										<td>
											<span>
												{{_.truncate(_.map(incidentInfo.emailInfo.recipients.cc, 'address').join(', '), {'length': showMore.cc ? 99999999 : 150, 'separator': ','})}}
												<a class="blue-link" style="text-decoration: underline;" *ngIf="incidentInfo.emailInfo.recipients.cc.join(', ').length > 150" (click)="showMore.cc = !showMore.cc">
													Show {{showMore.cc ? 'less' : 'more'}}
												</a>
											</span>
										</td>
									</tr>
									<tr *ngIf="incidentInfo.emailInfo.recipients?.bcc?.length">
										<td><b>Bcc: </b></td>
										<td>
											<span>
												{{_.truncate(_.map(incidentInfo.emailInfo.recipients.bcc, 'address').join(', '), {'length': showMore.bcc ? 99999999 : 150, 'separator': ','})}}
												<a class="blue-link" style="text-decoration: underline;" *ngIf="incidentInfo.emailInfo.recipients.bcc.join(', ').length > 150" (click)="showMore.bcc = !showMore.bcc">
													Show {{showMore.bcc ? 'less' : 'more'}}
												</a>
											</span>
										</td>
									</tr>
								</table>
								<div style="flex:1 0; overflow: auto;" class="flxClmn">
									<email-viewer [content]="accountCompromisedService.incidentInfoPopup.emailContent" style="min-height: 100%;"></email-viewer>
								</div>
								<btn-c class="absolute-centralize"
									   *ngIf="getEmailContentInProcess !== false;"
									   [loading]="getEmailContentInProcess"
									   (action)="getIncidentEmailContent();">
									Show Email Content
								</btn-c>
							</div>
							<div id="incidentInfoEmailAttachmentsContainer" *ngIf="incidentInfo.emailInfo?.sent.attachments.length">
								<hr style="width: 80%; margin: 10px auto;"/>
								<div class="flxRow hSpace1" style="margin: 0;">
									<div class="flxRow" style="flex:1 0; max-height: 66px; flex-wrap: wrap; overflow: auto;">
										<attachment-c
											*ngFor="let file of incidentInfo.emailInfo.sent.attachments"
											[attName]="file.name"
											[attSize]="file.size"
											[downloadProgress]="file.downloadProgressPrecentage"
											(preview)="previewAttachment = file;"
											(download)="downloadAttachment(file)">
										</attachment-c>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="threat-protection-card flxClmn" style="min-height: 180px;"
						 [ngClass]="accountCompromisedService.incidentInfoPopup.isUserAllowedToViewEmailContent ? 'ro9 co12' : 'ro24 co11'">
						<div class="card-header flxRow-between" style="align-items: center; height: 45px; padding: 7px 11px; justify-content: space-between;">
							<span class="card-title">
								Reviewers Activity {{incidentInfo.actions?.length ? '(' + incidentInfo.actions?.length + ')' : ''}}
							</span>
							<search-box [(model)]="reviewerSearchTxt"
										(modelChange)="searchReviewerActivity()"
										[isDisabled]="!incidentInfo.actions?.length"
										placeholder="Find in results">
							</search-box>
						</div>
						<div class="flxClmn" style="flex: 1 0; align-items: center; padding: 15px; overflow: auto;"
							 [ngStyle]="{'justify-content' : !incidentInfo.actions || !incidentInfo.actions?.length ? 'center' : ''}">
							<table style="text-align: left; width:100%; table-layout: fixed;" class="simpleDataTable" *ngIf="incidentInfo.actions && incidentInfo.actions?.length">
								<tr>
									<th style="width: 20%;">Created</th>
									<th style="width: 25%;">Reviewer</th>
									<th style="width: 50%;">Action</th>
								</tr>
								<tr *ngFor="let actionObj of incidentInfo.actions | orderBy: '-created'" [hidden]="actionObj.hide">
									<td>
										{{actionObj.created | date:'MM/dd/yyyy HH:mm'}}
									</td>
									<td class="ellipsis">
										{{actionObj.admin}}
									</td>
									<td>
										<span *ngIf="actionObj.name === 'note'">Note: {{actionObj.action}}</span>
										<span *ngIf="actionObj.name === 'securityReviewerActivity'">Security Reviewer - {{actionObj.action}}</span>
										<span *ngIf="actionObj.name !== 'note' && actionObj.name !== 'securityReviewerActivity'">{{incidentsActionsDic[actionObj.name]?.display || ''}}</span>
									</td>
								</tr>
							</table>
							<span style="opacity: 0.7;" *ngIf="!incidentInfo.actions || !incidentInfo.actions?.length">
								No activity by reviewers
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</popup-c>

<!--Change Incident Status popup-->
<popup-c class="overflownV" *ngIf="accountCompromisedService.setStatusPopup?.show"
	   head="Change Incident Status" size="dynamic"
		 (closeCb)="accountCompromisedService.setStatusPopup = null;"
	   (confirmCb)="setStatusConfirm(accountCompromisedService.setStatusPopup.incident, accountCompromisedService.setStatusPopup.incident.curStatus)"
	   [buttons]="{cancel: 'Cancel', confirm: 'Set'}">
	<div class="flxClmn vSpace3 f-1-0" style="overflow: visible;">
		<span>Update the incident's status. Current: <b style="text-transform: capitalize;">{{accountCompromisedService.setStatusPopup.incident.status}}</b></span>
		<div class="flxRow hSpace1" style="align-items: center;">
			<span>Status:</span>
			<app-dropdown-c style="width: 120px;" [text]="accountCompromisedService.setStatusPopup.incident.curStatus">
				<li *ngFor="let status of ['Approved', 'Suspicious', 'Compromised']"
					(click)="accountCompromisedService.setStatusPopup.incident.curStatus = status;"
					id="{{status}}">{{status}}
				</li>
			</app-dropdown-c>
		</div>
	</div>
</popup-c>


<attachment-preview
	*ngIf="previewAttachment"
	[attachment]="previewAttachment"
	(onClose)="previewAttachment = null;"
	[url]="'/admin/compromised/incidents/attachment/' + accountCompromisedService?.incidentInfoPopup?.IncidentInfo?.user_email + '/' + accountCompromisedService?.incidentInfoPopup?.IncidentInfo?._id + '/' + previewAttachment?._id">
</attachment-preview>

<popup-c *ngIf="accountCompromisedService.reviewerNotePopup"
		 head="Reviewer Note" size="small"
		 subTitle="Add your note below. The note will be displayed next to the incident"
		 (confirmCb)="accountCompromisedService.reviewerNotePopup?.doneCb()"
		 (closeCb)="accountCompromisedService.reviewerNotePopup = null;"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disable: accountCompromisedService.reviewerNotePopup.inProcess}}">
	<div class="flxClmn f-1-0" style="overflow: auto;">
			<textarea placeholder="Add your note here" style="flex: 1 0;"
					  [(ngModel)]="accountCompromisedService.reviewerNotePopup.note">
			</textarea>
	</div>
</popup-c>

<!--Create Incident popup-->
<popup-c class="bs-enabled" *ngIf="accountCompromisedService.incidentPopup?.show"
		 head="Create Incident" size="dynamic"
		 (closeCb)="accountCompromisedService.incidentPopup.show = false;"
		 (confirmCb)="accountCompromisedService.incidentPopup?.doneCb()"
		 [buttons]="{cancel: 'Cancel', confirm: {text: 'Confirm', disabled: accountCompromisedService.incidentPopup.applyInProcess || !accountCompromisedService.incidentPopup.securityTeamComments.length}}">
	<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
		<p style="font-size: 14px;">An email will be sent to all reviewers with details about this incident. You can add your questions to the reviewers below.</p>

		<div class="d-flex flex-column gap-1">
			<div style="white-space: nowrap;">Security team comments</div>
			<textarea type="text" placeholder="Information needed from reviewers"
					  style="max-height: 100px;" rows="2" [required]="true"
					  [(ngModel)]="accountCompromisedService.incidentPopup.securityTeamComments">
			</textarea>
		</div>
	</div>
</popup-c>

<popup-c *ngIf="reportWrongSensitivityPopup?.show"
		 head="Report Sensitivity Details"
		 (closeCb)="reportWrongSensitivityPopup = null"
		 (confirmCb)="reportWrongSensitivityPopup?.doneCb()"
		 [buttons]="{confirm: {text: 'Report'}}"
		 size="dynamic">
	<div class="flxClmn f-1-0 vSpace2 bs-enabled" style="overflow: auto;">
		<div class="flex-row align-items-center mt-2">
			If you believe the sensitivity score or type is incorrect, you can let us know below.
		</div>

		<div>
            <textarea style="width: 90%; height: 150px; margin-left: 5px;"
					  placeholder="Specify the result you received and what you believe the score/type should be"
					  [(ngModel)]="reportWrongSensitivityPopup.reportText">
            </textarea>
		</div>
	</div>
</popup-c>


<!--show account info popup-->
<account-user-info  *ngIf="showAccountInfoPopup"
					[showAccountInfoPopup]="showAccountInfoPopup"
					[mailboxEmail]="accountInfo.email"
					(close)="showAccountInfoPopup = false">
</account-user-info>
